import { Card } from 'react-bootstrap';
import '../styles/commonStyles.css';

const CardTemplate = ({ headerContent, bodyContent, footerContent }) => {
    return (
        <div className="d-flex justify-content-center">
            <Card className="card fanstore-card-container">
                <Card.Header className="cardHeader d-flex align-items-center">
                    {headerContent}
                </Card.Header>
                <Card.Body>
                    {bodyContent}
                </Card.Body>
                {footerContent && (
                    <Card.Footer>
                        {footerContent}
                    </Card.Footer>
                )}
            </Card>
        </div>
    );
};

export default CardTemplate; 